import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CredentialService } from "../../../credential.service";

@Component({
  standalone: false,
  selector: "app-azuresso",
  templateUrl: "./azuresso.component.html",
  styleUrls: ["./azuresso.component.scss"]
})
export class AzuressoComponent implements OnInit {
  hasError: boolean = false;
  azureError: boolean = false;

  constructor(
    private readonly routes: ActivatedRoute,
    private readonly userService: CredentialService,
    private readonly router: Router
  ) {
    this.routes.fragment.subscribe((fragment: string) => {
      const fragments: URLSearchParams = new URLSearchParams(fragment);
      const idToken: string = fragments.get("id_token");
      const stateToken: string = fragments.get("state");
      if (!idToken || !stateToken) {
        this.hasError = true;
      } else {
        this.performAzureSSOLogin(idToken, stateToken);
      }
    });
  }

  ngOnInit(): void {
    document.getElementById("initial_loader").remove();
  }

  performAzureSSOLogin(idToken: string, stateToken: string): void {
    this.userService.performAzureLogin(idToken, stateToken).subscribe(
      (authResponse: { token: string }): void => {
        this.userService.setLogin(authResponse);
        this.router.navigateByUrl(this.userService.getPostLoginUrl());
      },
      authError => {
        this.azureError = true;
        console.error(":::AZURE SSO COMPONENT | performAzureSSOLogin():::", authError, "::::::");
      }
    );
  }
}
